import moment from 'moment'

export default {
  namespaced: true,

  state: () => ({
    date: moment().isoWeekday(1).format('YYYY-MM-DD'),
  }),

  getters: {
    date(state) {
      return state.date
    },

    startDate(state) {
      return moment(state.date).isoWeekday(1).format('YYYY-MM-DD')
    },

    endDate(state) {
      return moment(state.date).isoWeekday(7).format('YYYY-MM-DD')
    },
  },

  mutations: {
    updateDate(state, date) {
      state.date = date
    },

    reset(state) {
      state.date = moment().isoWeekday(1).format('YYYY-MM-DD')
    },
  }
}
